import Header from "../components/Header"
import LanguageSet from "../components/language/LanguageSet"
import LanguageContext from "../components/hooks/LanguageContext"
import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faFilePdf, faImage, faVideo } from "@fortawesome/free-solid-svg-icons"
import MyVerticallyCenteredModalResource from "../components/MyVerticallyCenteredModalResource"
import Constants from "../common/Constants"
import { useAuth } from "../providers/AuthProvider"
import { getText } from "../utils/languageUtils"


const API_RESOURCES = `${Constants.BASE_URL}/appresources`;
const API_STUDENT_PROGRESS = `${Constants.BASE_URL}/studentprogress`;

// A resource carries only the files that were actually uploaded for it, so the
// API returns an empty path for the rest. Keep the icon where it is - dropping
// it would reshuffle the row - but render it as plain, unclickable content
// instead of a link that answers with a 404 page.
const ResourceLink = ({ href, className, style, download, children }) => {
    if (!href) {
        return (
            <span
                className={className}
                style={{ ...style, opacity: 0.35, cursor: "not-allowed" }}
                aria-disabled="true"
            >
                {children}
            </span>
        );
    }

    return (
        <a
            className={className}
            style={style}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            download={download}
        >
            {children}
        </a>
    );
};


const Resources = () => {
    const { user, logout: authLogout, authDispatch } = useAuth();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()
    const { language, translations: translationData } = useContext(LanguageContext);
    const translations = translationData?.question || {};
    const [module, setModule] = useState(null)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalItem, setModalItem] = useState('');
    const [modalItemType, setModalItemType] = useState('');

    useEffect(() => {
        fetchData(`${API_RESOURCES}?access_token=${user?.token}`, setModule);
    }, [user?.token]);

    const fetchData = (url, setData) => {
        setLoading(true);
        axios
            .get(url)
            .then((response) => {

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    setData(response.data);
                    setLoading(false);
                }

            })
            .catch((err) => {
                setLoading(false);
                console.error(err);
            });
    };

    const openModal = (title, item, type) => () => {

        setModalTitle(title);
        setModalItem(item);
        setModalItemType(type)
        setModalShow(true);
    };

    useEffect(() => {
        setLoading(true)
        let newUrl = `${API_STUDENT_PROGRESS}?access_token=${user?.token}`
        axios.post(newUrl).then((response) => {
            if (response.data.message === "Invalid Access Token") {
                authLogout()
                navigate("/");
            } else {
                const progress = response.data?.student_summary;
                authDispatch({ type: "SET_PROGRESS", payload: { points: progress.points, progress } });
                setLoading(false);
            }
        }).catch((err) => {
            console.error(err)
            setLoading(false)
        });
    }, [])

    return (
        <>
            <div id="body_bg">
                <Header page_title={getText(translations.learn_more, language)} />
                <LanguageSet />
                <div className="container-fluid px-0">
                    <div className="row justify-content-center">
                        <div className="col-xl-5 col-md-12">
                            <section className="my-3">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="sectionsBox">
                                                        <p className="mb-0 text-center">
                                                                    {getText(translations.learn_more, language)}
                                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-12 ">
                                            <div className="contentbox m-1">
                                                <div className="content_safty ">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <>
                                        <div className="row my-3">
                                            <div className="col-12">
                                                {module?.resource_summary?.map((item, index) => {
                                                    const externalLink = getText(item.external_link, language);
                                                    const pdfLink = getText(item.pdf_path, language);
                                                    const imageLink = getText(item.image_path, language);

                                                    return (
                                                            <div className="annoucemnet_bx mb-2" key={index}>
                                                                        <div className="row">
                                                                            <div className="col-7 d-flex justify-content-between align-items-center">

                                                                                <ResourceLink className="leftannou ms-5" style={{ textDecorationColor: "#2f4672" }} href={externalLink}>
                                                                                    <p className="mb-0" style={{ color: "#2f4672" }}>{getText(item.title, language)}</p>

                                                                                </ResourceLink>

                                                                            </div>
                                                                            <div className="col-1 justify-content-between align-items-center d-flex">
                                                                            </div>
                                                                            <div className="col-1 justify-conten-right align-items-center d-flex" onClick={openModal("Discreption", getText(item.description, language), "")}>
                                                                                <FontAwesomeIcon icon={faEye} size="sm" color="#002859" />
                                                                            </div>

                                                                            <div className="col-1 justify-content-right align-items-center d-flex">

                                                                                <ResourceLink href={externalLink} download className="me-5">
                                                                                    <FontAwesomeIcon icon={faVideo} size="sm" color="#002859" />
                                                                                </ResourceLink>

                                                                            </div>
                                                                            <div className="col-1 justify-content-between align-items-center d-flex">
                                                                                <div className="rightannou">
                                                                                    <ResourceLink className="leftannou " style={{ textDecorationColor: "#2f4672" }} href={pdfLink}>
                                                                                        <FontAwesomeIcon icon={faFilePdf} size="sm" color="#002859" />
                                                                                    </ResourceLink>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-1 justify-content-between align-items-center d-flex">
                                                                                <div className="rightannou">
                                                                                    <ResourceLink className="leftannou " style={{ textDecorationColor: "#2f4672" }} href={imageLink}>
                                                                                        <FontAwesomeIcon icon={faImage} size="sm" color="#002859" />
                                                                                    </ResourceLink>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                    );
                                                })
                                                }

                                            </div>
                                        </div>
                                        <MyVerticallyCenteredModalResource
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            title={modalTitle}
                                            imageLink={modalItem}
                                            modalItemType={modalItemType}
                                        />
                                    </>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Resources